<template>
  <div id="top-header">
    <dv-decoration-8 class="header-right-decoration"/>
    <dv-decoration-10 class="header-left-decoration"/>
    <dv-decoration-6 class="header-center-decoration" :color="['#50e3c2', '#67a1e5']" style="height:.1rem;"/>
    <dv-decoration-10 class="header-left-decoration" style="transform: rotateY(180deg);"/>
    <dv-decoration-8 class="header-right-decoration" :reverse="true"/>
    <el-button type="text" size="large" class="left-title">
      {{ dateTime.dateYear }} {{ dateTime.dateWeek }} {{ dateTime.dateDay }}
      {{ dataWeather.city }}
      {{ dataWeather.weathertemp }}
      <img :src="dataWeather.icontemp" alt="">
      {{ dataWeather.peraturetemp }}
    </el-button>

    <div class="center-title">骨密度信息系统大屏</div>
    <router-link to="/business" class="business-link">
      <el-button type="text" size="small" class="business-btn" title="业务大屏">
        <i class="el-icon-data-line"></i> 业务大屏
      </el-button>
    </router-link>
    <router-link to="/">
      <el-button type="text" size="large" class="go-system">
        进入系统
        <i class="el-icon-thumb"></i>
      </el-button>
    </router-link>
  </div>
</template>

<script>
import axios from 'axios'
import {weatherOption} from "../../config/weatherOption";

export default {
  name: "topHeader",
  data() {
    return {
      dateTime: {
        dateDay: null,
        dateYear: null,
        dateWeek: null,
        weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      },
      dataWeather: {
        city: '加载中...',
        dayweather: '***',
        nightweather: '***',
        weathertemp: '**℃', // 根据时间判断选白天还是晚上的天气
        nighttemp: '**℃',
        daytemp: '**℃',
        peraturetemp: '**℃-**℃', // 根据时间判断选白天还是晚上的温度
        icontemp: 'https://cdn.asilu.com/weather/icon/40/d00.png',
      },
      weatherTimer: null, // 天气刷新定时器
    }
  },
  mounted() {
    this.getDateTime()
    this.requestGetWeather()
    
    // 每60分钟更新一次天气
    this.weatherTimer = setInterval(() => {
      this.requestGetWeather()
    }, 60 * 60 * 1000)
  },
  beforeDestroy() {
    // 清理定时器
    if (this.weatherTimer) {
      clearInterval(this.weatherTimer)
      this.weatherTimer = null
    }
  },
  methods: {
    // 获取时间
    getDateTime() {
      setInterval(() => {
        this.dateTime.dateYear = this._parseTime(new Date(), '{y}-{m}-{d}');
        this.dateTime.dateWeek = this.dateTime.weekday[new Date().getDay()];
        this.dateTime.dateDay = this._parseTime(new Date(), '{h}:{i}:{s}');
      }, 1000)
    },
    // 获取天气 - 使用 Open-Meteo API + IP定位
    async requestGetWeather() {
      try {
        // 首先通过IP获取用户位置
        const location = await this.getLocationByIP()
        
        if (location) {
          let { latitude, longitude, city } = location
          
          // ✅ 如果没有经纬度，使用城市名称查询地理编码
          if (!latitude || !longitude) {
            const coords = await this.geocodeCity(city)
            if (coords) {
              latitude = coords.latitude
              longitude = coords.longitude
            }
          }
          
          // 如果有经纬度，调用 Open-Meteo API 获取天气数据
          if (latitude && longitude) {
            const response = await axios.get('https://api.open-meteo.com/v1/forecast', {
              params: {
                latitude: latitude,
                longitude: longitude,
                current_weather: true,
                daily: 'temperature_2m_max,temperature_2m_min,weathercode',
                timezone: 'auto'
              }
            })
            
            if (response.data && response.data.current_weather) {
              const current = response.data.current_weather
              const daily = response.data.daily
              
              // 解析天气数据
              const weatherInfo = this.parseWeatherData(current, daily)
              
              this.dataWeather = {
                city: city || '本地',
                weathertemp: `${current.temperature}℃`,
                daytemp: `${daily.temperature_2m_max[0]}℃`,
                nighttemp: `${daily.temperature_2m_min[0]}℃`,
                peraturetemp: `${daily.temperature_2m_min[0]}℃-${daily.temperature_2m_max[0]}℃`,
                icontemp: this.getWeatherIcon(current.weathercode),
                dataWeather: weatherInfo.description
              }
            }
          } else {
            // 无法获取坐标，使用默认城市
            this.getDefaultWeather()
          }
        } else {
          // 如果无法获取位置，使用默认城市（北京）
          this.getDefaultWeather()
        }
      } catch (error) {
        console.error('获取天气失败:', error)
        // 失败时使用默认天气
        this.getDefaultWeather()
      }
    },
    
    // 通过IP获取位置信息（使用Nginx反向代理解决CORS问题）
    async getLocationByIP() {
      try {
        // ✅ 方案1：通过Nginx代理访问 ip9.com.cn
        const response = await axios.get('/ip-proxy/ip9', {
          timeout: 5000,
        })
        
        if (response.data && response.data.ret === 200) {
          const data = response.data.data
          console.log(`IP定位成功 (ip9.com.cn): ${data.city}, ${data.prov}`)
          return {
            latitude: parseFloat(data.lat),
            longitude: parseFloat(data.lng),
            city: data.city || data.prov || '本地'
          }
        }
      } catch (error) {
        console.warn('ip9.com.cn 失败，尝试备用服务:', error.message)
      }
      
      try {
        // ✅ 方案2：通过Nginx代理访问 ipv46.upx8.com
        const response = await axios.get('/ip-proxy/ipv46', {
          timeout: 5000,
        })
        
        if (response.data && response.data.coordinates) {
          const data = response.data
          const regions = data.regions_short || []
          console.log(`IP定位成功 (ipv46.upx8.com): ${regions[1] || regions[0]}`)
          return {
            latitude: parseFloat(data.coordinates.latitude),
            longitude: parseFloat(data.coordinates.longitude),
            city: regions[1] || regions[0] || '未知城市'
          }
        }
      } catch (error) {
        console.warn('ipv46.upx8.com 失败，使用默认位置')
      }
      
      // ✅ 最终兜底：返回北京
      console.log('使用默认位置: 北京')
      return {
        latitude: 39.9042,
        longitude: 116.4074,
        city: '北京'
      }
    },
    
    // ✅ 地理编码：将城市名称转换为经纬度（支持中英文）
    async geocodeCity(cityName) {
      try {
        // ✅ 使用 Open-Meteo 的地理编码 API（免费，支持多语言）
        // 先尝试用中文名查询
        let response = await axios.get('https://geocoding-api.open-meteo.com/v1/search', {
          params: {
            name: cityName,
            count: 1,
            language: 'zh', // 优先使用中文
            format: 'json'
          }
        })
        
        if (response.data && response.data.results && response.data.results.length > 0) {
          const result = response.data.results[0]
          return {
            latitude: result.latitude,
            longitude: result.longitude,
            city: result.name // 返回中文名称
          }
        }
        
        // 如果中文查询失败，尝试用英文名查询
        if (cityName !== cityName.toLowerCase()) {
          // 可能是英文名，再次尝试
          response = await axios.get('https://geocoding-api.open-meteo.com/v1/search', {
            params: {
              name: cityName,
              count: 1,
              language: 'en',
              format: 'json'
            }
          })
          
          if (response.data && response.data.results && response.data.results.length > 0) {
            const result = response.data.results[0]
            return {
              latitude: result.latitude,
              longitude: result.longitude,
              city: result.name // 可能仍是英文
            }
          }
        }
        
        return null
      } catch (error) {
        console.error('地理编码失败:', error)
        return null
      }
    },
    
    // 解析天气数据
    parseWeatherData(current, daily) {
      const weatherCodes = {
        0: '晴朗',
        1: '主要晴朗',
        2: '多云',
        3: '阴天',
        45: '雾',
        48: '雾凇',
        51: '小毛毛雨',
        53: '中毛毛雨',
        55: '大毛毛雨',
        61: '小雨',
        63: '中雨',
        65: '大雨',
        71: '小雪',
        73: '中雪',
        75: '大雪',
        95: '雷雨',
        96: '雷阵雨伴冰雹',
        99: '强雷阵雨伴冰雹'
      }
      
      const description = weatherCodes[current.weathercode] || '未知'
      return { description, code: current.weathercode }
    },
    
    // 获取天气图标
    getWeatherIcon(weatherCode) {
      // Open-Meteo 天气代码映射到图标
      const iconMap = {
        0: 'd00', // 晴朗
        1: 'd01', // 主要晴朗
        2: 'd02', // 多云
        3: 'd04', // 阴天
        45: 'd50', // 雾
        48: 'd50', // 雾凇
        51: 'd07', // 小毛毛雨
        53: 'd07', // 中毛毛雨
        55: 'd07', // 大毛毛雨
        61: 'd08', // 小雨
        63: 'd09', // 中雨
        65: 'd10', // 大雨
        71: 'd14', // 小雪
        73: 'd15', // 中雪
        75: 'd16', // 大雪
        95: 'd11', // 雷雨
        96: 'd12', // 雷阵雨伴冰雹
        99: 'd12'  // 强雷阵雨伴冰雹
      }
      
      const iconCode = iconMap[weatherCode] || 'd00'
      return `https://cdn.asilu.com/weather/icon/40/${iconCode}.png`
    },
    
    // 获取默认天气（备用方案）
    getDefaultWeather() {
      this.dataWeather = {
        city: '北京',
        weathertemp: '20℃',
        daytemp: '25℃',
        nighttemp: '15℃',
        peraturetemp: '15℃-25℃',
        icontemp: 'https://cdn.asilu.com/weather/icon/40/d00.png',
        dataWeather: '晴朗'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
#top-header {
  position: relative;
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;

  .header-center-decoration {
    width: 40%;
    margin-top: 40px;
  }

  .header-left-decoration, .header-right-decoration {
    width: 25%;
  }

  .left-title {
    position: absolute;
    font-weight: bold;
    left: 60px;
    font-size: 15px; /* ✅ 天气栏字体大小 - 适中 */

    img {
      width: 20px; /* ✅ 天气图标大小 - 适中 */
      height: 20px;
      filter: brightness(3);
      vertical-align: bottom;
    }
  }

  .center-title {
    position: absolute;
    font-size: 24px;
    font-weight: bold;
    left: 50%;
    top: 15px;
    transform: translateX(-50%);
    color: #fff;
  }

  .go-system {
    display: none;
    position: absolute;
    font-weight: bold;
    right: 60px;
    color: #409eff;
    background-clip: text;
    -webkit-background-clip: text;
    animation: blink 2s linear infinite;
    -webkit-animation: blink 2s linear infinite;
    -moz-animation: blink 2s linear infinite;
    -ms-animation: blink 2s linear infinite;
    -o-animation: blink 2s linear infinite;
  }

  .business-link {
    text-decoration: none;
  }

  .business-btn {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: #67c23a;
    font-size: 14px;
    font-weight: bold;
    padding: 8px 15px;
    border: 1px solid rgba(103, 194, 58, 0.3);
    border-radius: 4px;
    background: rgba(103, 194, 58, 0.1);
    transition: all 0.3s;
  }

  .business-btn:hover {
    color: #fff;
    background: rgba(103, 194, 58, 0.3);
    border-color: rgba(103, 194, 58, 0.6);
  }

}

// 平板端和手机横屏适配
@media screen and (min-width: 769px) {
  #top-header {
    .center-title {
      font-size: 28px !important;
    }
    
    .left-title {
      font-size: 14px !important; /* ✅ 平板端天气栏字体 - 适中 */
      left: 30px !important;
      
      img {
        width: 16px !important; /* ✅ 平板端天气图标 - 适中 */
        height: 16px !important;
      }
    }
    
    .business-btn {
      font-size: 12px !important;
      padding: 6px 12px !important;
    }
  }
}

// 手机竖屏适配
@media screen and (max-width: 768px) and (orientation: portrait) {
  #top-header {
    height: auto !important;
    min-height: 80px;
    flex-direction: column !important;
    padding: 10px !important;
    
    .header-center-decoration {
      width: 60% !important;
      margin-top: 10px !important;
    }
    
    .header-left-decoration, 
    .header-right-decoration {
      width: 20% !important;
    }
    
    .left-title {
      position: relative !important;
      left: auto !important;
      font-size: 13px !important; /* ✅ 移动端天气栏字体 - 适中 */
      text-align: center;
      margin: 5px 0 !important;
      order: 2;
      
      img {
        width: 15px !important; /* ✅ 移动端天气图标 - 适中 */
        height: 15px !important;
      }
    }
    
    .center-title {
      position: relative !important;
      left: auto !important;
      top: auto !important;
      transform: none !important;
      font-size: 16px !important;
      margin: 5px 0 !important;
      order: 1;
      text-align: center;
    }
    
    .business-link {
      order: 3;
      text-align: center;
      margin: 5px 0;
    }
    
    .business-btn {
      position: relative !important;
      right: auto !important;
      top: auto !important;
      transform: none !important;
      font-size: 12px !important;
      padding: 6px 12px !important;
    }
    
    .go-system {
      display: none !important;
    }
  }
}

// ✅ 1080p 屏幕专属优化
@media screen and (min-width: 1920px) and (max-width: 2560px) and (min-height: 1080px) and (max-height: 1440px) {
  #top-header {
    .left-title {
      font-size: 18px !important; // ✅ 增大天气栏字体
      
      img {
        width: 24px !important;
        height: 24px !important;
      }
    }
    
    .business-btn {
      font-size: 16px !important;
      padding: 8px 20px !important;
    }
  }
}
</style>
<style>
@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}

@-webkit-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}

@-moz-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}

@-ms-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}

@-o-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}
</style>
